/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/dialog/style/css';
import { ElForm as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/form/style/css';
import { ElUpload as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/upload/style/css';
import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import { ElTag as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/tag/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/input/style/css';
import { ElAlert as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/alert/style/css';
import _asyncToGenerator from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = {
  key: 0,
  style: {
    "padding": "0 0 20px"
  }
};
var _hoisted_2 = {
  class: "file-upload-container"
};
var _hoisted_3 = {
  class: "dialog-footer",
  style: {
    "padding-top": "0"
  }
};
var _hoisted_4 = {
  class: "btn-box"
};
import { ref, onMounted, nextTick } from "vue";
import { ElMessage } from "element-plus";
import { useDicStore } from "@/store/dictionary";
import { approval_check } from "@/api/apis";
import { systemType } from "@/constants";
export default {
  __name: 'ApprovalDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    approvalId: {
      type: [String, Number],
      required: true
    },
    originId: {
      type: [String, Number],
      required: true
    },
    beforeSubmit: {
      type: Function,
      default: null
    },
    showUpload: {
      type: Boolean,
      default: false
    },
    alertMessage: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "success", "close"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var visible = ref(false);
    var fileList = ref([]);
    var ruleFormRef = ref(null);
    var ruleForm = ref({});
    var customWords = ref([]);
    var rules = {
      remark: [{
        required: true,
        message: "请输入审批备注",
        trigger: ["blur", "change"]
      }]
    };
    var dicStore = useDicStore();
    var headers = {
      "system-type": systemType,
      Authorization: "Bearer " + localStorage.getItem("token_blk")
    };
    var uploadAction = process.env.VUE_APP_BASE_URL + "/api/file/add_file";

    // 获取自定义词语
    var getCustomWords = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        try {
          var res = yield dicStore.get_dic("快捷常用语");
          customWords.value = res;
        } catch (error) {
          console.error("获取快捷常用语失败:", error);
        }
      });
      return function getCustomWords() {
        return _ref2.apply(this, arguments);
      };
    }();

    // 文件预览
    var handlePreview = file => {
      var _file$response;
      var url = ((_file$response = file.response) === null || _file$response === void 0 ? void 0 : _file$response.data.file_url) || file.url;
      var eleLink = document.createElement("a");
      eleLink.href = url; // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click(); // 然后移除
      document.body.removeChild(eleLink);
    };

    // 文件移除
    var handleRemove = (file, fileList) => {};

    // 文件上传成功
    var isFileUploading = ref(false);
    var handleUploadSuccess = (res, file, type, index) => {
      isFileUploading.value = true;
      if (res.code != 200) {
        ElMessage({
          type: "error",
          message: res.msg || "上传失败"
        });
        nextTick(() => {
          var fileIndex = fileList.value.findIndex(item => item.uid === file.uid);
          if (fileIndex > -1) {
            fileList.value.splice(fileIndex, 1);
          }
        });
        return false;
      }
    };
    // 设置备注
    var handleSetRemark = remark => {
      ruleForm.value.remark = remark;
    };
    var submitting = ref(false);
    // 处理审批结果
    var handleResult = type => {
      if (submitting.value) {
        return;
      }
      ruleFormRef.value.validate(valid => {
        if (valid) {
          submitting.value = true;
          // 如果提供了beforeSubmit回调，则先执行回调
          if (props.beforeSubmit) {
            // 执行回调并传入审批参数和继续执行的函数
            props.beforeSubmit(type, ruleForm.value.remark, null, handleSubmit);
          } else {
            // 如果没有提供回调，则直接提交
            handleSubmit(type, ruleForm.value.remark);
          }
        } else {
          ElMessage({
            type: "error",
            message: "请输入审批备注"
          });
        }
      });
    };

    // 提交审批
    var handleSubmit = function handleSubmit(type, remark) {
      var additionalData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var obj = {
        approval_flow_id: props.approvalId,
        status: type,
        remark: remark || ruleForm.value.remark,
        origin_id: props.originId
      };

      // 如果启用了附件上传并且有文件，则添加文件ID
      if (props.showUpload && fileList.value.length > 0) {
        obj.file_ids = fileList.value.map(file => {
          var _file$response2;
          // 如果是新上传的文件，使用response中的file_id
          // 如果是已有文件，使用file_id属性
          return ((_file$response2 = file.response) === null || _file$response2 === void 0 || (_file$response2 = _file$response2.data) === null || _file$response2 === void 0 ? void 0 : _file$response2.file_id) || file.file_id;
        }).filter(id => id); // 过滤掉空值
      }
      if (additionalData !== null && additionalData !== void 0 && additionalData.record) {
        obj.record = additionalData.record;
      }
      approval_check(obj, "put").then(res => {
        if (res.code == 200) {
          ElMessage({
            type: "success",
            message: "操作成功"
          });
          visible.value = false;
          fileList.value = [];
          emit("success", res);
        }
      }).finally(() => {
        submitting.value = false;
      });
    };

    // 关闭弹窗
    var handleClose = () => {
      ruleForm.value = {};
      fileList.value = []; // 清空文件列表
      emit("close");
      emit("update:modelValue", false);
    };

    // 监听modelValue变化
    onMounted(() => {
      getCustomWords();
    });

    // 监听visible变化
    watch(() => props.modelValue, val => {
      visible.value = val;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      var _component_el_alert = __unplugin_components_0;
      var _component_el_input = __unplugin_components_1;
      var _component_el_form_item = __unplugin_components_2;
      var _component_el_tag = __unplugin_components_3;
      var _component_el_button = __unplugin_components_4;
      var _component_el_upload = __unplugin_components_5;
      var _component_el_form = __unplugin_components_6;
      var _component_el_dialog = __unplugin_components_7;
      return _openBlock(), _createBlock(_component_el_dialog, {
        class: "my-approval-dialog",
        "close-on-click-modal": false,
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => visible.value = $event),
        title: "审批",
        width: "600px",
        "align-center": "",
        onClose: handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
          class: "btn warning",
          onClick: _cache[2] || (_cache[2] = $event => handleResult(2)),
          style: _normalizeStyle({
            opacity: submitting.value ? 0.6 : 1,
            cursor: submitting.value ? 'not-allowed' : 'pointer'
          })
        }, " 拒绝 ", 4), _createElementVNode("div", {
          class: "btn primary",
          onClick: _cache[3] || (_cache[3] = $event => handleResult(1)),
          style: _normalizeStyle({
            opacity: submitting.value ? 0.6 : 1,
            cursor: submitting.value ? 'not-allowed' : 'pointer'
          })
        }, " 通过 ", 4)])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: ruleForm.value,
          rules: rules,
          "label-width": "120px",
          "label-position": "left",
          "status-icon": ""
        }, {
          default: _withCtx(() => [__props.alertMessage ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_alert, {
            title: __props.alertMessage,
            type: "error",
            closable: false
          }, null, 8, ["title"])])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "审核备注",
            prop: "remark",
            style: {
              "width": "100%",
              "align-items": "start"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              modelValue: ruleForm.value.remark,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ruleForm.value.remark = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "",
            style: {
              "width": "100%",
              "align-items": "start"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customWords.value, item => {
              return _openBlock(), _createBlock(_component_el_tag, {
                key: item.encode,
                style: {
                  "cursor": "pointer",
                  "margin-right": "20px",
                  "margin-bottom": "10px"
                },
                type: "info",
                onClick: $event => handleSetRemark(item.full_name)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.full_name), 1)]),
                _: 2
              }, 1032, ["onClick"]);
            }), 128))]),
            _: 1
          }), __props.showUpload ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "附件",
            style: {
              "width": "100%",
              "align-items": "start"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_upload, {
              "file-list": fileList.value,
              "onUpdate:fileList": _cache[1] || (_cache[1] = $event => fileList.value = $event),
              class: "upload-demo",
              data: {
                content_type: 5
              },
              headers: headers,
              action: uploadAction,
              multiple: "",
              "on-preview": handlePreview,
              "on-remove": handleRemove,
              "on-success": handleUploadSuccess
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                plain: "",
                round: "",
                icon: "UploadFilled"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 上传附件 ")])),
                _: 1
              })]),
              _: 1
            }, 8, ["file-list"])])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};